import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { PortfolioParams } from '../../models/params.interface';
import { Entity } from '../../models/entity.interface';
import { SentimentItemizedResponse } from '../../models/sentiment.interface';
import { EntityInfoService } from '../metadata-api/entity-info.service';
import { SentimentService } from './sentiment.service';

/**
 * Volume stats only. sentiment_itemized also returns sentiment/sentiment_delta
 * and pos/neg/neu, but no caller reads them — sentiment comes from score_ts v2.
 */
export interface PortfolioItem {
  entity: Entity;
  count: number;
  volume_ratio: number;
}

export interface PortfolioTreemap {
  treemap: { children: PortfolioItem[] };
}

@Injectable({
  providedIn: 'root',
})
export class PortfolioService {
  constructor(
    private entityInfoService: EntityInfoService,
    private sentimentService: SentimentService,
  ) {}

  getPortfolio(
    iparams: PortfolioParams,
    folio: string[],
  ): Observable<PortfolioTreemap> {
    // 'array' mode always resolves to Entity[]; the signature's union covers
    // the keyed mode too.
    return (
      this.entityInfoService.getEntitiesInfo(
        folio,
        'array',
        iparams.getSanctions ? true : false,
      ) as Observable<Entity[]>
    ).pipe(
      mergeMap((entities: Entity[]) => {
        const content = entities.map((item: Entity) => item.compound_key);
        return this.sentimentService
          .getSentimentItemized(content, iparams)
          .pipe(
            map((sentiments) => this.constructTreemap(entities, sentiments)),
          );
      }),
    );
  }

  private constructTreemap(
    entities: Entity[],
    sentiments: SentimentItemizedResponse,
  ): PortfolioTreemap {
    console.log('entities', entities);
    console.log('sentiments', sentiments);
    const children = entities.map((entity) => {
      const stats = sentiments[entity.compound_key];
      return {
        entity,
        count: stats?.count,
        volume_ratio: stats?.volume_ratio,
      };
    });

    return { treemap: { children } };
  }
}
